import React from 'react'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import { ReactComponent as MotionDetectionOnIcon } from '../images/motion-detection-on.svg'
import { ReactComponent as MotionDetectionOffIcon } from '../images/motion-detection-off.svg'
import { ReactComponent as SettingsIcon } from '../images/settings.svg'

const styles = (theme) => ({
    controlsIconButton: {
        color: theme.palette.common.white,
    },
    controlsIconButtonIcon: {
        color: theme.palette.common.white,
        display: 'flex',
        alignItems: 'center',
    },
})

const CameraControls = ({
    isMotionOn,
    disabled = false,
    hideMotion = false,
    motionDisabled = false,
    motionFunc,
    motionRef = null,
    hideSettings = false,
    settingsFunc,
    settingsRef = null,
}) => {
    const renderButtons = () => {
        const buttons = []
        if (!hideMotion) {
            buttons.push({
                id: 'motionDetection',
                text: 'motionDetection',
                onClick: disabled ? null : motionFunc,
                ref: motionRef,
                icon: isMotionOn ? (
                    <MotionDetectionOnIcon />
                ) : (
                    <MotionDetectionOffIcon />
                ),
                disabled: motionDisabled,
                tooltip: false,
            })
        }
        if (!hideSettings) {
            buttons.push({
                id: 'settings',
                onClick: disabled ? null : settingsFunc,
                ref: settingsRef,
                icon: <SettingsIcon />,
                tooltip: false,
            })
        }

        return buttons.map((ele) => {
            if (ele === null) {
                return
            }
            const button = (
                <div
                    key={ele.id}
                    onClick={(e) => {
                        ele.onClick(e)
                    }}
                    className={classnames('button', {
                        disabled: disabled || ele.disabled,
                    })}
                >
                    <div className="icon" ref={ele.ref}>
                        {ele.icon}
                    </div>
                    {ele.text && (
                        <div className="text">
                            <FormattedMessage id={ele.text} />
                        </div>
                    )}
                </div>
            )
            if (ele.tooltip) {
                return (
                    <Tooltip
                        title={<FormattedMessage id={ele.id} />}
                        placement="top"
                        key={ele.id}
                    >
                        {button}
                    </Tooltip>
                )
            } else {
                return button
            }
        })
    }

    const buttons = renderButtons()

    if (buttons.length > 0) {
        return <div className="camera-controls">{buttons}</div>
    } else {
        return null
    }
}

export default withStyles(styles)(CameraControls)
